<!--
 * @Author: wufei
 * @Date: 2020-08-07 16:07:48
 * @LastEditTime: 2020-10-14 14:40:10
 * @Description:
 * @FilePath: \mobile-revive\src\views\index\bigData.vue
-->
<template>
  <div class="big-data" @click="popdown">
    <div v-if="show" class="mask" />
    <header>
      <ul>
        <li :class="{active:show === 'year'}" @click.stop="showPopup('year')">{{ showYear }} <icon name="arrow-down" /></li>
        <li :class="{active:show === 'month'}" @click.stop="showPopup('month')"><div class="monthList">{{ showMonth }}</div> <icon name="arrow-down" /></li>
        <li :class="{active:show === 'department'}" @click.stop="showPopup('department')">
          <div class="busList">
            {{ showBus }}
          </div>
          <icon name="arrow-down" />
        </li>
        <li :class="{active:show === 'city'}" @click.stop="showPopup('city')">
          <div class="busList">
            {{ showCity }}
          </div>
          <icon name="arrow-down" />
        </li>
      </ul>
      <div v-if="show" class="popup">
        <picker
          v-show="show == 'year'"
          title="请选择年份"
          :columns="years"
          :default-index="yearIndex"
          @change="yearChange"
        />

        <div v-show="show == 'month'" class="months">
          <div v-for="item in months" :key="item.text" class="item" :class="{active:item.state,disable:!item.enabled}" @click.stop="monthSelected(item)">{{ item.text }}月</div>
        </div>

        <picker
          v-show="show == 'department'"
          title="请选择事业部"
          value-key="orgShortName"
          :columns="BussinesDepList"
          :default-index="busIndex"
          @change="busChange"
        />

        <picker
          v-show="show == 'city'"
          title="请选择城市公司"
          value-key="orgShortName"
          :columns="cityCompanyList"
          :default-index="cityIndex"
          @change="cityChange"
        />
      </div>
    </header>

    <div class="pie-container">
      <title-comp :title="showName+'-误判'">
        <template v-slot:right>
          <ul class="menu">
            <li :class="{active:menu === 'all'}" @click="switchMenu('all')">全部</li>|
            <li :class="{active:menu === 'get'}" @click="switchMenu('get')">我司获取</li>|
            <li :class="{active:menu === 'point'}" @click="switchMenu('point')">重点跟进</li>
          </ul>
        </template>

      </title-comp>
      <div v-if="menu === 'all'" key="all" ref="allCharts" class="myCharts pie-chart" />
      <div v-if="menu === 'get'" key="get" ref="getCharts" class="myCharts pie-chart" />
      <div v-if="menu === 'point'" key="point" ref="pointCharts" class="myCharts pie-chart" />
    </div>

    <div class="bar-container">
      <div ref="barCharts" class="myCharts bar-chart" />
    </div>

  </div>
</template>

<script>
import { setTitle } from '@/api/dd'
import { getBussinesDeptList, getCitycompanyList, getDataDict } from '@/api/sys'
import { Icon, Picker, Toast } from 'vant'
import TitleComp from '@/components/TitleComp'
import { reviveChart, lineChart, findOpeningTimeMonth } from '@/api/revive'
export default {
    name: 'BigData',
    components: {
        Icon,
        Picker,
        TitleComp
    },
    data() {
        return {
            userBelong: JSON.parse(sessionStorage.getItem('userBelone')),
            UA: 'mobile',
            currentDate: new Date().getFullYear(),
            show: '',
            years: [],
            months: [],
            selectedMonth: [],
            currYear: new Date().getFullYear(),
            yearIndex: 0,
            currBus: '',
            currCity: '',
            busIndex: 0,
            cityIndex: 0,
            BussinesDepList: [],
            cityCompanyList: [],
            menu: 'all',
            allChart: '',
            getChart: '',
            pointChart: '',
            // 饼状图数据
            pieData: {
                allSurpassNum: 0, // 量价全超项目数
                priceTradeQtyNum: 0, // 以价换量项目数
                priceOvertopNum: 0, // 量价高估项目数
                priceNoMarketNum: 0, // 有价无市项目数
                regretNum: 0, // 遗憾项目数
                noRegretNum: 0// 非遗憾项目数
            },
            // 柱状图数据
            lineData: {
                busList: [], // 事业部列表
                oneList: [], // 精准比例列表
                twoList: [], // 合格比例列表
                threeList: [] // 误判比例列表
            }

        }
    },
    computed: {
        showYear() {
            if (this.currYear) {
                return this.currYear
            }
            return '年份'
        },
        showMonth() {
            let text = ''
            if (this.selectedMonth.length) {
                this.selectedMonth.forEach(item => {
                    text += item.text + '月 '
                })
                text.trim()
                return text
            }
            return '月份'
        },
        showBus() {
            const bus = this.BussinesDepList.find(item => item.orgDeptId === this.currBus)
            if (bus) {
                return bus.orgShortName
            }
            return '事业部'
        },
        showCity() {
            const bus = this.cityCompanyList.find(item => item.orgDeptId === this.currCity)
            if (bus) {
                return bus.orgShortName
            }
            return '全部'
        },
        showName() {
            if (this.currCity) {
                return this.showCity
            }
            return this.showBus
        }
    },
    watch: {
        // pieData: {
        //     handler() {
        //         this.initAllChart()
        //     },
        //     deep: true
        // },
        selectedMonth(n) {
            this.months.forEach(item => {
                const select = n.find(month => month.text === item.text)
                item.state = false
                if (select) {
                    item.state = true
                }
            })
        },
        yearIndex(n) {
            const item = this.years[n]
            this.currYear = item.text
            this.getData()
            this.findOpeningTimeMonth()
        },
        busIndex(n) {
            const item = this.BussinesDepList[n]
            this.currBus = item.orgDeptId
            this.cityIndex = 0
            if (this.currBus) {
                this.getCitycompanyList()
            } else {
                this.cityCompanyList = []
                const all = {
                    orgDeptId: '',
                    orgShortName: '全部'
                }
                this.cityCompanyList.unshift(all)
            }
            this.getData()
        },
        cityIndex(n) {
            const item = this.cityCompanyList[n]
            this.currCity = item.orgDeptId
            this.getData()
        },
        menu(n) {
            switch (n) {
            case 'all':
                this.initAllChart()
                break
            case 'get':
                this.initGetChart()
                break
            case 'point':
                this.initPointChart()
                break
            default:
                break
            }
        }
    },
    async created() {
        setTitle('复盘大数据')
        await this.initYear()
        let navigator = window.navigator.userAgent
        if (/ipad/gi.test(navigator)) {
            this.UA = 'ipad'
        }
        console.log('UA', this.UA)
    },
    async mounted() {
        await this.getBussinesDeptList()
        if (this.userBelong.type === 3) {
            await this.getCitycompanyList()
        }
        await this.findOpeningTimeMonth()
        await this.initAllChart()
        await this.initLineChart()
        // this.allChart = this.$echarts.init(this.$refs.allCharts)

    },
    methods: {
        async findOpeningTimeMonth() {
            const selectMonth = this.selectedMonth.map(item => {
                if (item.text < 10) {
                    return '0' + item.text
                }
                return item.text
            })
            const parmas = {
                openingTimeYear: this.currYear,
                deptId: this.currBus,
                cityCompId: this.currCity
            }
            await findOpeningTimeMonth(parmas).then(res => {
                this.months.forEach(item => {
                    const month = res.find(month => +month == item.text)
                    if (month) {
                        item.enabled = true
                    } else {
                        item.enabled = false
                        item.state = false
                    }
                })
                this.selectedMonth = this.months.filter(item => item.state)
            })
        },
        async initLineChart() {
            await this.lineChart()
            setTimeout(() => {
                const barChart = this.$echarts.init(this.$refs.barCharts)
                barChart.setOption(
                    {
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: { // 坐标轴指示器，坐标轴触发有效
                                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                            },
                            formatter(data) {
                                let html = ''
                                data.forEach((item, index) => {
                                    html += `${item.marker} ${item.seriesName}: ${item.value}%<br/>`
                                })
                                return html
                            }
                        },
                        title: {
                            subtext: '单位:%',
                            top: 10,
                            right: 0
                        },
                        color: ['#61A0A8', '#2F4554', '#C23531'],
                        legend: {
                            bottom: 0,
                            icon: 'rect',
                            data: ['精准', '合格', '误判']
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '7%',
                            containLabel: true
                        },
                        yAxis: {
                            type: 'value'
                        },
                        xAxis: {
                            type: 'category',
                            // data: ['浙江', '华北', '江苏', '武汉', '深圳', '西南', '太原', '太原', '太原', '太原', '太原', '太原', '太原', '太原', '太原', '太原', '太原'],
                            data: this.lineData.busList,
                            axisLabel: {
                                formatter: function(value) {
                                    value = value.replace('区域集团', '')
                                        .replace('城市更新', '城更')
                                        .replace('城市公司', '')
                                        .replace('事业部', '')
                                        .replace('区域集团', '')
                                        .replace('旭辉银盛泰集团', '')
                                        .replace('办事处', '')
                                        .replace('公司', '')
                                        .replace('区域', '')
                                    return value.split('').join('\n')
                                }
                            }
                        },
                        series: [
                            {
                                name: '精准',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    position: 'insideRight'
                                },
                                // data: [320, 302, 301, 334, 390, 330, 320]
                                data: this.lineData.oneList
                            },
                            {
                                name: '合格',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    position: 'insideRight'
                                },
                                // data: [120, 132, 101, 134, 90, 230, 210]
                                data: this.lineData.twoList
                            },
                            {
                                name: '误判',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    position: 'insideRight'
                                },
                                // data: [220, 182, 191, 234, 290, 330, 310]
                                data: this.lineData.threeList
                            }
                        ]})
            }, 300)

        },
        async initPointChart() {
            const selectMonth = this.selectedMonth.map(item => {
                if (item.text < 10) {
                    return '0' + item.text
                }
                return item.text
            })
            const parmas = {
                openingTimeYear: this.currYear,
                openingTimeMonths: selectMonth,
                deptId: this.currBus,
                cityCompId: this.currCity,
                isFocus: 1
            }
            await this.reviveChart(parmas)
            setTimeout(() => {
                this.pointChart = this.$echarts.init(this.$refs.pointCharts)
                this.pointChart.setOption({
                    legend: {
                        icon: 'circle',
                        orient: 'vertical',
                        // bottom: -50,
                        bottom: 0,
                        data: ['量价低估', '以价换量', '量价高估', '有价无市'],
                        formatter: function(name) {
                            const arr = [
                                {name: '量价低估', extend: '均价低估10%以上，流量低估20%以上'},
                                {name: '以价换量', extend: '均价高估10%以上，流量低估20%以上'},
                                {name: '量价高估', extend: '均价高估10%以上，流量高估20%以上'},
                                {name: '有价无市', extend: '均价低估10%以上，流量高估20%以上'}
                            ]
                            const item = arr.find(item => item.name === name)
                            return name + ':' + item.extend
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            selectedMode: 'single',
                            top: -100,
                            radius: [0, '50%'],
                            // radius: [0, '90%'],
                            label: {
                                position: 'inner'
                            },
                            labelLine: {
                                show: false
                            },
                            dataZoom: [
                                {
                                    type: 'slider',
                                    show: true
                                }
                            ],
                            data: [
                                {value: this.pieData.allSurpassNum, name: '量价低估', label: {color: 'rgba(0,0,0,0)'}},
                                {value: this.pieData.priceTradeQtyNum, name: '以价换量', label: {color: 'rgba(0,0,0,0)'}},
                                {value: this.pieData.priceOvertopNum, name: '量价高估', label: {color: 'rgba(0,0,0,0)'}},
                                {value: this.pieData.priceNoMarketNum, name: '有价无市', label: {color: 'rgba(0,0,0,0)'}}
                            ]
                        }
                    ]
                })
            }, 300)
        },
        async initGetChart() {
            const selectMonth = this.selectedMonth.map(item => {
                if (item.text < 10) {
                    return '0' + item.text
                }
                return item.text
            })
            const parmas = {
                openingTimeYear: this.currYear,
                openingTimeMonths: selectMonth,
                deptId: this.currBus,
                cityCompId: this.currCity,
                isObtains: 1
            }
            await this.reviveChart(parmas)
            setTimeout(() => {
                this.getChart = this.$echarts.init(this.$refs.getCharts)
                this.getChart.setOption({
                    legend: {
                        icon: 'circle',
                        orient: 'vertical',
                        // bottom: -50,
                        bottom: 0,
                        data: ['量价低估', '以价换量', '量价高估', '有价无市'],
                        formatter: function(name) {
                            const arr = [
                                {name: '量价低估', extend: '均价低估10%以上，流量低估20%以上'},
                                {name: '以价换量', extend: '均价高估10%以上，流量低估20%以上'},
                                {name: '量价高估', extend: '均价高估10%以上，流量高估20%以上'},
                                {name: '有价无市', extend: '均价低估10%以上，流量高估20%以上'}
                            ]
                            const item = arr.find(item => item.name === name)
                            return name + ':' + item.extend
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            selectedMode: 'single',
                            top: -100,
                            radius: [0, '50%'],
                            // radius: [0, '90%'],
                            label: {
                                position: 'inner'
                            },
                            labelLine: {
                                show: false
                            },
                            dataZoom: [
                                {
                                    type: 'slider',
                                    show: true
                                }
                            ],
                            data: [
                                {value: this.pieData.allSurpassNum, name: '量价低估', label: {color: 'rgba(0,0,0,0)'}},
                                {value: this.pieData.priceTradeQtyNum, name: '以价换量', label: {color: 'rgba(0,0,0,0)'}},
                                {value: this.pieData.priceOvertopNum, name: '量价高估', label: {color: 'rgba(0,0,0,0)'}},
                                {value: this.pieData.priceNoMarketNum, name: '有价无市', label: {color: 'rgba(0,0,0,0)'}}
                            ]
                        }
                    ]
                })
            }, 300)
        },
        async initAllChart() {
            const selectMonth = this.selectedMonth.map(item => {
                if (item.text < 10) {
                    return '0' + item.text
                }
                return item.text
            })
            const parmas = {
                openingTimeYear: this.currYear,
                openingTimeMonths: selectMonth,
                deptId: this.currBus,
                cityCompId: this.currCity
            }
            await this.reviveChart(parmas)
            setTimeout(() => {
                this.allChart = this.$echarts.init(this.$refs.allCharts)
                this.allChart.setOption({
                    legend: {
                        icon: 'circle',
                        orient: 'vertical',
                        // bottom: -50,
                        bottom: 0,
                        data: ['量价低估', '以价换量', '量价高估', '有价无市', '遗憾项目'],
                        formatter: function(name) {
                            const arr = [
                                {name: '量价低估', extend: '均价低估10%以上，流量低估20%以上'},
                                {name: '以价换量', extend: '均价高估10%以上，流量低估20%以上'},
                                {name: '量价高估', extend: '均价高估10%以上，流量高估20%以上'},
                                {name: '有价无市', extend: '均价低估10%以上，流量高估20%以上'},
                                {name: '遗憾项目', extend: '非我司获取的量价低估项目'}
                            ]
                            const item = arr.find(item => item.name === name)
                            return name + ':' + item.extend
                        }
                    },
                    color: ['#2F4554', '#C23531', '#D48265', '#61A0A8', '#87C9AC'],
                    tooltip: {
                        trigger: 'item',
                        // formatter: '{b} : {c} ({d}%)'
                        formatter(value) {
                            if (value.name !== '非遗憾项目') {
                                return `${value.name} : ${value.value} (${value.percent}%)`
                            }
                            return ''
                        }
                    },
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            selectedMode: 'single',
                            top: -100,
                            radius: [0, '40%'],
                            label: {
                                position: 'inner'
                            },
                            labelLine: {
                                show: false
                            },
                            dataZoom: [
                                {
                                    type: 'slider',
                                    show: true
                                }
                            ],
                            data: [
                                {value: this.pieData.allSurpassNum, name: '量价低估', label: {color: 'rgba(0,0,0,0)'}},
                                {value: this.pieData.priceTradeQtyNum, name: '以价换量', label: {color: 'rgba(0,0,0,0)'}},
                                {value: this.pieData.priceOvertopNum, name: '量价高估', label: {color: 'rgba(0,0,0,0)'}},
                                {value: this.pieData.priceNoMarketNum, name: '有价无市', label: {color: 'rgba(0,0,0,0)'}}
                            ]
                        },
                        {
                            name: '访问来源',
                            type: 'pie',
                            top: -100,
                            radius: ['45%', '60%'],
                            label: {
                                // position: 'inner',
                                formatter: '{a|{b}\n{c}个}',
                                // formatter: '{b|{b}：}\n{c}  {per|{d}%}  ',
                                align: 'center',
                                color: 'black',
                                rich: {
                                    a: {
                                        align: 'center'
                                    },
                                    hr: {
                                        // borderColor: '#aaa',
                                        width: '100%',
                                        // borderWidth: 0.5,
                                        height: 0
                                    },
                                    b: {
                                        fontSize: 14,
                                        lineHeight: 33
                                    },
                                    per: {
                                        color: '#eee',
                                        backgroundColor: '#334455',
                                        padding: [2, 4],
                                        borderRadius: 2
                                    }
                                }
                            },
                            labelLine: {
                                length: 1
                                // length2: 1
                            },
                            data: [
                                {value: this.pieData.regretNum, name: '遗憾项目'},
                                {value: this.pieData.noRegretNum, name: '非遗憾项目', itemStyle: {opacity: 0}, labelLine: {show: false}, label: {show: false}}

                            ]
                        }
                    ]
                })
            }, 300)
        },
        async reviveChart(data) {
            await reviveChart(data).then(res => {
                this.pieData.allSurpassNum = res.allSurpassNum
                this.pieData.priceTradeQtyNum = res.priceTradeQtyNum
                this.pieData.priceOvertopNum = res.priceOvertopNum
                this.pieData.priceNoMarketNum = res.priceNoMarketNum
                // this.pieData.regretNum = res.regretNum
                this.pieData.regretNum = res.regretNum
                this.pieData.noRegretNum = res.allSurpassNum + res.priceTradeQtyNum + res.priceOvertopNum + res.priceNoMarketNum
            })
        },
        async lineChart() {
            const selectMonth = this.selectedMonth.map(item => {
                if (item.text < 10) {
                    return '0' + item.text
                }
                return item.text
            })
            const parmas = {
                openingTimeYear: this.currYear,
                openingTimeMonths: selectMonth,
                deptId: this.currBus,
                cityCompId: this.currCity
            }
            await lineChart(parmas).then(res => {
                this.lineData.busList = []
                this.lineData.oneList = []
                this.lineData.twoList = []
                this.lineData.threeList = []
                res.forEach(item => {
                    this.lineData.busList.push(item.orgName)
                    this.lineData.oneList.push(parseInt(item.evalTypeOneRate * 100, 10) || 0)
                    this.lineData.twoList.push(parseInt(item.evalTypeTwoRate * 100, 10) || 0)
                    this.lineData.threeList.push(parseInt(item.evalTypeThreeRate * 100, 10) || 0)
                })
            })
        },
        switchMenu(type) {
            this.menu = type
        },
        getData() {
            console.log('menu', this.menu)
            switch (this.menu) {
            case 'all':
                this.initAllChart()
                break
            case 'get':
                this.initGetChart()
                break
            case 'point':
                this.initPointChart()
                break
            default:
                break
            }
            this.initLineChart()
        },
        busChange(picker, value, index) {
            this.busIndex = index
        },
        cityChange(picker, value, index) {
            this.cityIndex = index
        },
        yearChange(picker, value, index) {
            this.yearIndex = index
        },
        async getBussinesDeptList() {
            let type = 292700
            let ids = []
            await getDataDict({type}).then(res => {
                ids = JSON.parse(res[0].otherCode)
            })
            console.log(ids)
            // const ids = ['10010000', '10100000', '10040000', '10030000', '50007348', '10270000',
            //     '10120000', '10150000', '10070000', '10020000', '50007031', '10060000', '10170000', '10080000', '10130000', '10110000']

            await getBussinesDeptList().then(res => {
                this.BussinesDepList = res
                this.BussinesDepList = this.BussinesDepList.filter(item => {
                    if (ids.includes(item.orgDeptId)) {
                        return item
                    }
                })
                this.BussinesDepList.forEach(item => {
                    item.orgShortName = item.orgShortName
                        .replace('区域集团', '')
                        .replace('城市更新', '城更')
                        .replace('城市公司', '')
                        .replace('事业部', '')
                        .replace('区域集团', '')
                        .replace('旭辉银盛泰集团', '')
                        .replace('办事处', '')
                        .replace('公司', '')
                        .replace('区域', '')
                })
                const all = {
                    orgDeptId: '',
                    orgShortName: '全国'
                }

                this.BussinesDepList.unshift(all)

                if (this.userBelong.type != 1) {
                    this.BussinesDepList = this.BussinesDepList.filter(item => item.orgDeptId === this.userBelong.areaDeptId)
                    this.currBus = this.userBelong.areaDeptId
                }
            })
        },
        async getCitycompanyList() {
            await getCitycompanyList(this.currBus).then(res => {
                this.cityCompanyList = res
                this.cityCompanyList.forEach(item => {
                    item.orgShortName = item.orgShortName
                        .replace('城市公司', '')
                        .replace('商业管理公司', '')
                        .replace('土地拓展小组', '')
                        .replace('商用事业部', '')
                        .replace('事业部', '')
                        .replace('区域', '')
                })
                const all = {
                    orgDeptId: '',
                    orgShortName: '全部'
                }
                this.cityCompanyList.unshift(all)

                if (this.userBelong.type === 3) {
                    this.cityCompanyList = this.cityCompanyList.filter(item => item.orgDeptId === this.userBelong.cityCompId)
                    this.currCity = this.userBelong.cityCompId
                }
            })
        },
        popdown() {
            // if (!this.selectedMonth.length) {
            //     this.initYear()
            // }
            if (this.show) {
                switch (this.menu) {
                case 'all':
                    this.initAllChart()
                    break
                case 'get':
                    this.initGetChart()
                    break
                case 'point':
                    this.initPointChart()
                    break
                default:
                    break
                }
                this.initLineChart()
            }

            this.show = false
        },
        getActive(month) {
            const item = this.selectedMonth.find(item => item == month)
            if (item) {
                return true
            }
            return false
        },
        monthSelected(month) {
            if (!month.enabled) {
                Toast.fail('该月份不可选')
                return false
            }
            month.state = !month.state
            if (month.state) {
                this.selectedMonth.push(month)
            }

            this.selectedMonth = this.months.filter(item => item.state)
            // let flag = false
            // if (this.selectedMonth.length) {
            //     this.selectedMonth.forEach(item => {
            //         if (Math.abs(month.text - item.text) <= 1) {
            //             flag = true
            //         }
            //     })
            // } else {
            //     flag = true
            // }

            // if (flag) {
            //     month.state = !month.state
            //     this.monthCheck(month)
            // } else {
            //     Toast.fail('多个月份必须是连续的')
            // }

        },
        monthCheck(month) {
            let {text, state} = month
            this.selectedMonth = this.months.filter(item => item.state)
            let min = 13
            let max = 0
            this.selectedMonth.forEach(item => {
                if (min > item.text) {
                    min = item.text
                }
                if (max < item.text) {
                    max = item.text
                }
            })
            // console.log('max', max, 'min', min)
            if (!state) {
                if (text < min) return
                if (text < max) {
                    this.selectedMonth = this.selectedMonth.filter(item => {
                        return item.text < text
                    })
                }
            }

        },
        initYear() {
            this.years = []
            this.months = []
            // const minYear = this.currentDate - 100
            for (let i = 2019;i <= this.currentDate;i++) {
                this.years.push({text: i})
            }
            this.yearIndex = this.years.length - 1

            let month = new Date().getMonth()
            month = month === 0 ? 12 : month
            // 如果是12月份年份回到上一年
            this.yearIndex = month === 12 ? this.yearIndex - 1 : this.yearIndex
            // 默认选中上个月
            for (let i = 1;i <= 12;i++) {
                this.months.push({text: i, state: month === i})
                if (month === i) {
                    this.selectedMonth.push({text: i, state: month === i})
                }
            }
        },
        showPopup(type) {
            this.show = type
        }
    }
}
</script>

<style lang='scss' scoped>
  .big-data {
    box-sizing: border-box;
    height:9999px;
    width:100%;
    height:100%;
    overflow-y: auto;
    background:rgba(248,248,248,1);
    font-size:.28rem /* 28/100 */;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    padding-bottom: 1.5rem;
    .mask {
      width:100%;
      height:100%;
      background:rgba(0,0,0,0.42);
      position: absolute;
      z-index: 98;
    }
    header {
      z-index:99;
      width:100%;
      height:.9rem /* 90/100 */;
      background: white;
      position: relative;
      ul {
        display:flex;
          padding:0 .3rem;
        li {
          display:flex;
          justify-content: center;
          flex:1;
          line-height:.9rem /* 90/100 */;
          .monthList {
            max-width:1.5rem /* 100/100 */;
            white-space: nowrap;
            text-overflow:ellipsis;
            overflow:hidden;
          }
          .busList {
            min-width:.5rem;
            max-width:1rem /* 100/100 */;
            white-space: nowrap;
            text-overflow:ellipsis;
            overflow:hidden;
          }
          i {
            line-height:.9rem /* 90/100 */;
          }
        }
        li.active {
          color:#2761FF;
        }
      }
    .popup {
      position: absolute;
      z-index:99;
      width:100%;
      .months {
        display: flex;
        flex-wrap: wrap;
        background: white;
        padding:.25rem /* 10/100 */;
        .item {
          width:1.55rem /* 155/100 */;
          height:.46rem /* 46/100 */;
          background:rgba(247,247,247,1);
          border-radius:.04rem /* 4/100 */;
          margin:.1rem /* 20/100 */;
          font-size:.24rem /* 24/100 */;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(110,110,110,1);
          line-height:.46rem /* 46/100 */;
          text-align: center;
        }
        .active {
          background:#2761FF;
          color:white;
        }
        .disable {
          background:rgba(0,0,0,.6);
          color:white;
        }
      }
    }
    }
    .pie-container {
      box-sizing: border-box;
      width:95% /* 690/100 */;
      box-shadow:0px 2px 10px 0px rgba(0,0,0,0.13);
      margin:0 auto;
      background: white;
      margin-top:.3rem /* 30/100 */;
      padding:.35rem /* 35/100 */ .4rem /* 40/100 */;
      .pie-chart {
        height:6.5rem /* 395/100 */
      }
      .menu {
        display:flex;
        line-height: .4rem /* 28/100 */;
        li {
          font-size:.28rem /* 28/100 */;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          margin: 0 .1rem;
        }
        li.active {
          color:rgba(39,97,255,1);
        }
      }
    }

    .bar-container {
      .bar-chart {
        height:6.5rem /* 395/100 */
      }
    }

  }
</style>

<style lang="scss">
    .big-data {
        .van-picker-column {
            // font-size:.24rem /* 24/100 */;
        }
    }
</style>
